//  @ts-nocheck
import * as R from 'ramda';
import { navigatorTo } from 'utils/util';
import { inject, observer } from 'mobx-react';
import { ThemeContext } from 'store/ThemeProvider';
import { IComponentGallery, IComponentLink } from 'component';
import React, { useState, useEffect, useContext } from 'react';

import Type1 from './Type1';
import Type3 from './Type3';
import Type2 from './Type2';
import Type4 from './Type4';
import RootStore from '../../store/RootStore';
import SearchRow from '../ComponentVote/Search';

import './Type.scss';

interface IRenderType {
  data: any;
  index: number;
  mode: string;
  info?: boolean;
  total?: boolean;
  showname?: boolean;
  namealign?: string;
  cid: string;
  currentGallerys?: any;
  onClick: (opt: IComponentLink) => void;
}

export const renderGalleryName = (desc?: string, custom?: string) => {
  if (custom) {
    let array = custom.split(/\n/);
    return array.map((it: string, index: number) => {
      return <p key={index}>{it}</p>;
    });
  }

  return desc;
};

export const renderGalleryType = (props: IRenderType) => {
  const {
    data,
    index,
    mode,
    info = true,
    total = true,
    showname = true,
    namealign = 'left',
    imageadjust = false,
    cid,
    currentGallerys,
    onClick,
  } = props;
  let Component;
  switch (mode) {
    case '1':
      Component = Type1;
      break;
    case '2':
      Component = Type2;
      break;
    case '3':
      Component = Type3;
      break;
    case '4':
      Component = Type4;
      break;
    default:
      return null;
  }
  return (
    <Component
      key={cid + index}
      {...data}
      info={info}
      total={total}
      showname={showname}
      namealign={namealign}
      imageadjust={imageadjust}
      onClick={onClick}
      gallerys={currentGallerys}
    />
  );
};

export interface IAllForGallery extends IComponentGallery {
  rootStore?: RootStore;
}
const AllForGallery = (props: IAllForGallery) => {
  const {
    cid,
    list = [],
    mode,
    rootStore,
    info,
    total,
    search,
    showname,
    namealign,
    imageadjust,
  } = props;

  const { pagedataStore } = rootStore!;
  const { currentGallerys } = pagedataStore;

  const onClick = (opt: IComponentLink) => {
    navigatorTo(opt);
  };

  useEffect(() => {
    let ids: string[] = [
      // 默认包含当前主相册信息
      Number(window.gallery!.id) > 1 ? window.gallery!.id + '' : '',
    ];
    list.forEach((it: any) => {
      let { link } = it;
      if (link && link.type == 'subgallery') {
        ids.push(link.value);
      }
      if (link && link.type == 'gallery') {
        ids.push(link.value);
      }
    });
    // noinspection JSIgnoredPromiseFromCall
    pagedataStore.getGallerys(ids.filter(Boolean));
  }, []);

  // 搜索的处理逻辑
  const [filter, setFilter] = useState('');
  const searchFilter = (item: any) => {
    if (filter) {
      const { link } = item;

      {
        //  这儿是查看原始数据是否包含搜索的关键字
        const objectDesc = R.pathOr('', ['desc'], item);
        const objectLinkDesc = R.pathOr('', ['link', 'desc'], item);
        const desc = objectDesc || objectLinkDesc;

        const descIncludes = desc.includes(filter);
        if (descIncludes) {
          return true;
        }

        //  如果没有包含, 那么走到下面的逻辑, 从第二个维度进行检索
      }
      {
        // 获取到对应的实体数据
        const target = currentGallerys[link.value];
        if (target) {
          const name = R.pathOr('', ['name'], target);
          return name.includes(filter);
        } else {
          //  没有实体数据, 那么就不匹配
          return false;
        }
      }
    } else {
      //  没有搜索条件, 那么直接返回所有数据
      return true;
    }
  };

  const onSearch = (keywords: string) => {
    setFilter(keywords);
  };

  const { h1Color, h2Color, mainColor } = useContext(ThemeContext);
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        padding: '5px 0',
      }}
    >
      {search ? (
        <div className="gallery-list-search common-search">
          <SearchRow
            search={onSearch}
            placeholder="请输入关键内容"
            h1Color={h1Color}
            h2Color={h2Color}
            mainColor={mainColor}
          />
        </div>
      ) : null}
      {list.filter(searchFilter).map((one, index) => {
        return renderGalleryType({
          data: one,
          index,
          mode,
          info,
          total,
          showname,
          namealign,
          imageadjust,
          cid,
          currentGallerys,
          onClick,
        });
      })}
    </div>
  );
};

export default inject('rootStore')(observer(AllForGallery));
